import { h, render } from "preact";

export default async (el, path) => {
    try {
        const { default: Template } = await import(`../${path}`);
        const config = JSON.parse(
            el.getElementsByTagName("script")[0].innerHTML
        );
        render(<Template config={config} />, el);
    } catch (err) {
        console.warn(err);
    }
};
